import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
import lodash from "lodash";
import { getStorageData } from "framework/src/Utilities";
import {
  IUserContext,
  ReceiptPrinterSetting,
} from "../../../blocks/navigationmenu/src/HeaderController.web";
// import { CatalogueCarController } from "../../../blocks/catalogue/src/CatalogueCardController.web";

import {
  CustomEnums,
  getCustomEnumName,
  PermissionStatus,
  checkForNewPermissonStatus,
  customPermissionApiKey,
  sortCondition,
  conditionalString,
} from "../../utilities/src/CustomBlockHelpers";
import { makeApiMessage } from "../../../components/src/common";
import {
  ICustomerDataWithPreference,
  IPreferenceItem,
} from "../../../blocks/ProductDescription/src/CustomerPreferenceViewController.web";
import {
  ICartProductItem,
  UpchargeIds,
  UpchargeMainList,
  PaymentMethodType,
  EditSpecificationType,
} from "./utils";
import {
  IMyUser,
  PermissionGroupArray,
} from "../../../blocks/navigationmenu/src/utils";
import {
  CartsItemsPreferencesData,
  CatalogueList,
  CreatePreferencesParams,
  CustomerDataType,
  CustomerSpecification,
  IOrderSpecification,
  IlaundryOrder,
  IlaundryOrderItem,
  StoreOrderItem,
  IpreferenceDataList,
  Service,
  UpdateOrderBody,
  UpdateGoldenPointOrderBody,
} from "../../../components/src/Interface";
import { SelectedPreferenceData } from "../../../blocks/ProductDescription/src/EditPreferenceController";

export const ORDER_TYPES = {
  STORE_ORDER: "storeOrders",
  PLANT_ORDER: "plantOrders",
  CLEANING_ORDER: "cleaningOrders",
};

export const Actions = {
  ADD_QUANTITY: "add_quantity",
  CHANGE_NOTES: "change_note",
  CLEAR_CUSTOMER: "clear_customer",
  REMOVE_QUANTITY: "remove_quantity",
  CHANGE_MAIN_TAB: "change_main_tab",
  SUMMARY_NEW_ORDER: "summary_new_order",
  CHANGE_ORDER_NOTES: "change_order_notes",
  CHANGE_COUNTRY_CODE: "change_country_code",
  CHANGE_CUSTOMER_PHONE: "change_customer_phone",
  OPEN_ADD_QUANTITY_POPUP: "open_add_quantity_popup",
  CLOSE_ADD_QUANTITY_POPUP: "close_add_quantity_popup",
};

export interface IPhoneValue {
  id: number;
  option: string;
  full_phone_number: string;
  country_code: number;
}

export interface IFormValues {
  id?: number;
  notes?: string;
  width?: string;
  height?: string;
  weight?: string;
  quantity: number;
  measurement_type?: string[];
  catalogue_id?: number | string;
  isNew: boolean;
  [field: string]: string | number | boolean | undefined | string[];
}

export interface ICatalogueTypes {
  data: {
    id: string;
    attributes: {
      id: number;
      name: string;
      price: string;
      second_name: string;
      name_translation: string;
      home_cleaning_catalogue_id: number;
    };
  };
}

export interface ISnackbar {
  open: boolean;
  message: string;
}
export const ProductType = {
  NORMAL: "noraml",
  PARENT: "Parent",
  SUBPRODUCT: "Sub-Product",
};

interface IOrderItem {
  id: string;
  type: string;
  attributes: {
    tag_numbers: any;
    id: number;
    order_management_order_id: number;
    no_of_pieces: number;
    unit_price: string;
    notes: string;
    total_price: string;
    golden_point_name: string;
    catalogue_id: number;
    customer_id: string;
    golden_point_items_attributes: {
      golden_point_id: number;
      quantity: number;
    };
    category_id: number;
    total_points: string;
    start_date_base: string;
    end_date_base: string;
    price: string;
    final_price: string;
    free_wash_quentity: string;
    quantity: number;
    bonus_points: string;
    golden_point_text_en: string;
    base_points: string;
    order_statuses: {
      order_number: string;
      placed_at: null | string;
      confirmed_at: null | string;
      in_transit_at: null | string;
      delivered_at: null | string;
      cancelled_at: null | string;
      refunded_at: null | string;
    };
    catalogue: {
      id: number;
      name: string;
      total_points: string;
      start_date_base: string;
      end_date_base: string;
      price: string;
      final_price: string;
      free_wash_quentity: string;
      quantity: number;
      bonus_points: string;
      golden_point_text_en: string;
      base_points: string;
    };
    product_image: string;
    preference: null | string;
    upcharge_list_ids: Array<UpchargeIds>;
  };
}

export interface IOrder {
  length: number;
  id: number;
  order_number: string;
  amount: null | string;
  account_id: number;
  total_final_price: number;
  sub_total: string;
  name: string[];
  transactions: [];
  total_upcharge_amount: string;
  customer: {
    id: number;
    full_phone_number: string;
    email: string;
    full_name: string;
  };
  total: string;
  status: string;
  cancellation_reason: null | string;
  order_date: null | string;
  placed_at: null | string;
  confirmed_at: null | string;
  delivered_at: null | string;
  delivery_charges: null | string;
  payment_failed_at: null | string;
  payment_pending_at: null | string;
  tax_charges: string;
  store_name: string;
  deliver_by: null | string;
  tracking_number: null | string;
  is_error: boolean;
  order_status_id: number;
  is_group: boolean;
  is_availability_checked: boolean;
  total_tax: string;
  no_of_items: number;
  no_of_pieces: number;
  created_at: string;
  updated_at: string;
  delivery_addresses: [] | null;
  // no_of_tags: number;
  razorpay_order_id: null | string;
  charged: null | string;
  invoice_id: null | string;
  invoiced: null | string;
  save_for_future: boolean;
  notes: string;

  order_items: IOrderItem[];
  total_price: number;
  total_vat: number;
  total_vat_amount: number;
  order_transactions: {
    id: string;
    attributes: {
      id: number;
      account_id: number;
      order_management_order_id: number;
      total_points: string;
      start_date_base: string;
      end_date_base: string;
      price: string;
      final_price: string;
      free_wash_quentity: string;
      quantity: number;
      bonus_points: string;
      golden_point_text_en: string;
      base_points: string;
      amount: string;
      payment_method: {
        id: number;
      };
    };
  }[];
  paid_at: string | null;
  order_created_by: {
    id: number;
    first_name: string;
    last_name: string;
  };
  currency: string;
  discount_summary?: {
    has_promotion: boolean;
  };
}

export type IOrderArray = IOrder[];

export interface Store {
  id: string;
  type: string;
  attributes: {
    id: number;
    store_name: string;
  };
}
export interface ICustomer {
  id: string;
  attributes: {
    full_name: string;
    activated: boolean;
    email: string;
    date_of_birth: string;
    phone_number: number;
    country_code: number;
    customer_profile?: {
      data: {
        id: string;
        type: string;
        attributes: {
          street_address: null | string;
          city: null | string;
          employee_id: string;
          customer_id: string;
          post_code: null | string;
          business_id: null | string;
          price_list: {};
          notes: null | string;
          gender_id: null | string;
          private_note: null | string;
          customer_type: string;
          profession: {
            data: null;
          };
          organisation_tax: {
            data: null;
          };
          payment: {
            id: null;
            name: null;
          };
          organization: {
            data: null;
          };
        };
      };
    };
    customer_preferences_attributes: IPreferenceItem[];
    order: IOrder;
    saved_notes: null;
  };
}

interface Meta {
  total_pages: number;
  total_count: number;
  current_page: number;
  next_page: number | undefined;
  pervious_page: number | undefined;
}
export interface IPaymentOption {
  id: number;
  name: string;
  active: boolean;
}

export interface ICartProduct {
  catalogue_id: number;
  catalogue_variant_id: number;
  title: string;
  price: string | number;
  image: string;
  quantity: number;
  serviceName: string;
  serviceId: number | string;
  parentProductId: null | string | number;
  tabsId: number;
  productSecondName?: string;
  serviceShortName?: string;
  upcharge_price: string;
}
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  catalogue: CatalogueList;
  selectedServiceId?: number | string;
  tabsId?: number;
  serviceClickHandler: Function;
}

interface S {
  // Customizable Area Start
  txtInputValue: string;
  txtSavedValue: string;
  enableField: boolean;
  tabsId: number;
  cartTotalOpen: boolean;
  paymentOptions: IPaymentOption[];
  paymentMethod: string;
  cataloguesList: CatalogueList[];
  catalogueListEmptyFlag: boolean;
  cataloguesListMeta: Meta;
  userData: IMyUser | undefined;
  activated: false;
  userRefresh: () => void;
  storeId: number;
  storeList: { id: string; option: string }[];
  cartProducts: ICartProductItem[];
  beforePopupCartProducts: ICartProductItem[];
  addCustomerPopup: boolean;
  addProductPopup: boolean;
  viewCustomerPopup: boolean;
  isLoading: boolean;
  mobileNumberError: string;
  customerData?: ICustomer;
  countryCodeInput: string;
  customerId: null | string;
  previousPhoneNumber: string;
  previousCustomer?: ICustomer;
  orderSummaryVisible?: boolean;
  clearPhoneNumber?: boolean;
  isEdit: boolean | null;
  productPreferenceOpen: boolean;
  saveForFuture: boolean;
  orderNotes: string;
  snackbarOpen: boolean;
  paymentModalVisible: boolean;
  orderTryAgainModalVisible: boolean;
  sameProductDifferentServiceModalVisible: boolean;
  clickedProductIndex: number;
  errorSnackbarOpen: boolean;
  snackbarSeverity: "error" | "warning" | "info" | "success";
  errorMessage: string;
  preferenceModalVisible: boolean;
  customerPhone: string;
  successSnackBarMessage: string;
  order?: { attributes: IOrder };
  cartItemHoverId: {
    catalogue_id: number | null;
    tabsId: number | null;
    serviceName: string | null;
  };
  customerDataWithPreference: ICustomerDataWithPreference | undefined;
  customersList: unknown[];
  itemsAddedToCartForPreference: {
    catalogue_variant_id: number;
    preferenceId: number;
    serviceId: number;
  }[];
  isQuickDrop: boolean;
  quickDropCount: number;
  currentPage: number;
  editId?: boolean;
  temporaryProducts: CatalogueList[];
  paymentClicked: boolean;
  quickDropReceivedCount: number;
  storeListPageNo: number;
  storeSearchText: string;
  enableHomeCleaningSettings: boolean;
  selectedMainTab: string;
  productPopup: boolean;
  carpetFurnitureProductPopupData: CatalogueList | null;
  pickupDate: Date | null;
  UpchargeMainList: UpchargeMainList[];
  searchText: string;
  isCatalogueCardLoading: boolean;
  subProductModalOpen: boolean;
  clickedParentCatalougeId: number | null;
  selectedCustomer: CustomerDataType | null;
  selectedProductQuantity: { [key: string]: number };
  productQuantities: Record<string, number>;
  editSelectedCustomer: {
    id: number;
    fullPhoneNumber: string;
    email: string;
    fullName: string;
    business?: string | null;
    fullAddress: string;
  } | null;
  selectedService: {
    name: string;
    id: number;
  } | null;
  laundryOrderItems: Array<IlaundryOrderItem>;
  StoreOrderItem: Array<StoreOrderItem>;
  laundryOrder: IlaundryOrder | null;
  idQuickDropUpdatApiCall: boolean;
  cartsItemsPreferencesData: Array<CartsItemsPreferencesData>;
  clickedProductCardInfo: ICartProductItem | null;
  isIncreaseBtnClicked: boolean;
  selectedCatalogueData: CatalogueList | null;
  notes: string;
  isPopuDisabledWithOrderCreate: boolean;
  isEditPreferencesPopupOpen: boolean;
  permissionStatus: PermissionStatus;
  userCustomerPriceList: boolean;
  userCustomerPriceListId: number | null;
  highlightedSectionIds: number[];
  printerSetting: ReceiptPrinterSetting | null;
  isClearCartActionCall: boolean;
  isB2bActive: boolean;
  // Customizable Area End
}

interface SS {
  // Customizable Area Start
  id: number | string;
  // Customizable Area End
}

export default class AljabrStoreController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  getProductApiCallId: string = "";
  getCatalogueListApiId: string = "";
  getTemporaryProductListApiId: string = "";
  getProductPreferencesApiId: string = "";
  updateEmployeeCurrentStoreApiId: string = "";
  createNewOrderApiId: string = "";
  getOrderApiId: string = "";
  createPreferenceApiId: string = "";
  getStoreListApiId: string = "";
  getCustomerListApiId: string = "";
  searchCustomerApiCallId: string = "";
  orderNotesTimeout: NodeJS.Timeout | string = "";
  searchCustomerApiMessageId: string = "";
  plantProductListMessageId: string = "";
  homeCleaningOrderMessageId: string = "";
  mobileNumberInput: string = "";
  orderTimeout: string | number | NodeJS.Timeout | undefined = undefined;
  storeListEmptyFlag: boolean = false;
  getPreferencesDataApiCallId: string = "";
  updateOrderApiCallID: string = "";
  createOrderApiCallID: string = "";
  updatePreferencesApicallId: string = "";
  getPaymentMethodsApiCallId: string = "";
  shouldUseCommonUpchargesPreference = false;
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      // Customizable Area Start
      getName(MessageEnum.AccoutLoginSuccess),
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
      getName(MessageEnum.RestAPIResponceSuccessMessage),
      getName(MessageEnum.RestAPIResponceErrorMessage),
      getName(MessageEnum.NavigationPayLoadMessage),
      getName(MessageEnum.RestAPIResponceDataMessage),
      getName(MessageEnum.LayoutDataMessage),
      getName(MessageEnum.SearchTextMessage),
      getName(MessageEnum.BroadcastNavbarDataMessage),
      getCustomEnumName(CustomEnums.CustomActionReducers),
    ];

    this.state = {
      // Customizable Area Start
      txtInputValue: "",
      txtSavedValue: "A",
      enableField: false,
      idQuickDropUpdatApiCall: false,
      isQuickDrop: false,
      quickDropCount: 0,
      tabsId: 0,
      previousPhoneNumber: "",
      activated: false,
      paymentMethod: "",
      cataloguesList: [],
      productQuantities: {},
      catalogueListEmptyFlag: false,
      cataloguesListMeta: {
        total_pages: 0,
        total_count: 0,
        current_page: 0,
        next_page: undefined,
        pervious_page: undefined,
      },
      userData: {} as IMyUser,
      userRefresh: () => {},
      storeId: -1,
      storeList: [],
      cartProducts: [],
      beforePopupCartProducts: [],
      addCustomerPopup: false,
      addProductPopup: false,
      viewCustomerPopup: false,
      isLoading: false,
      mobileNumberError: "",
      countryCodeInput: "+966",
      customerId: null,
      isEdit: false,
      productPreferenceOpen: false,
      saveForFuture: false,
      paymentModalVisible: false,
      orderTryAgainModalVisible: false,
      sameProductDifferentServiceModalVisible: false,
      clickedProductIndex: -1,
      snackbarOpen: false,
      orderNotes: "",
      snackbarSeverity: "warning",
      errorSnackbarOpen: false,
      preferenceModalVisible: false,
      errorMessage: "",

      customerPhone: "",

      successSnackBarMessage: "",
      cartItemHoverId: {
        catalogue_id: null,
        tabsId: null,
        serviceName: null,
      },
      customerDataWithPreference: undefined,
      customersList: [],

      itemsAddedToCartForPreference: [],
      currentPage: 1,
      temporaryProducts: [],
      paymentClicked: false,
      cartTotalOpen: false,
      paymentOptions: [],
      quickDropReceivedCount: 0,
      storeListPageNo: 1,
      storeSearchText: "",
      selectedMainTab: ORDER_TYPES.STORE_ORDER,
      productPopup: false,
      carpetFurnitureProductPopupData: null,
      enableHomeCleaningSettings: false,
      pickupDate: null,
      UpchargeMainList: [],
      searchText: "",
      isCatalogueCardLoading: false,
      subProductModalOpen: false,
      clickedParentCatalougeId: null,
      selectedCustomer: null,
      selectedProductQuantity: {},
      editSelectedCustomer: null,
      selectedService: null,
      laundryOrderItems: [],
      StoreOrderItem: [],
      laundryOrder: null,
      cartsItemsPreferencesData: [],
      clickedProductCardInfo: null,
      isIncreaseBtnClicked: false,
      selectedCatalogueData: null,
      notes: "",
      isPopuDisabledWithOrderCreate: false,
      isEditPreferencesPopupOpen: false,
      permissionStatus: {
        mainPermission: false,
        createPermission: true,
        viewPermission: false,
        editPermission: false,
        deactivatePermission: false,
      },
      userCustomerPriceList: false,
      userCustomerPriceListId: null,
      highlightedSectionIds: [],
      printerSetting: null,
      isClearCartActionCall: false,
      isB2bActive: false,
      // Customizable Area End
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  async receive(from: string, message: Message) {
    runEngine.debugLog("Message Recived", message);
    if (message.id === getName(MessageEnum.RestAPIResponceMessage)) {
      this.handleResponse(message);
    } else if (
      getCustomEnumName(CustomEnums.CustomActionReducers) === message.id
    ) {
      this.handleCustomReducer(message);
    }

    this.retrieveSearchTextData(message);
    this.extractDataFromLayout(message);
    this.receiveDataFromHeader(message);
    // Customizable Area End
  }

  // Customizable Area Start
  async componentDidMount() {
    super.componentDidMount();
    if (!this.state.isB2bActive) this.handleGetPaymentAPI();
  }


  retrieveSearchTextData = (message: Message) => {
    if (message.id === getName(MessageEnum.SearchTextMessage)) {
      const recievedData = message.getData(
        getName(MessageEnum.SearchMessageText)
      );
      if (recievedData) {
        this.handleSearch(recievedData.searchText);
      }
    }
  };

  extractDataFromLayout = (message: Message) => {
    if (message.id === getName(MessageEnum.LayoutDataMessage)) {
      const recievedData = message.getData(
        getName(MessageEnum.LayoutMessageData)
      );
      if (recievedData.userContext) {
        this.handleOnUserChange(recievedData.userContext);
      }
    }
  };

  receiveDataFromHeader = async (message: Message) => {
    if (message.id === getName(MessageEnum.BroadcastNavbarDataMessage)) {
      const recievedData = message.getData(
        getName(MessageEnum.BroadcastNavbarData)
      );
      let storeID = await getStorageData("store_id");
      if (recievedData.singleStoreID != storeID && recievedData.singleStoreID) {
        this.handleStoreChange();
        this.updateEmployeeCurrentStore(recievedData.singleStoreID);
      }
    }
  };

  handleCheckApiCallWithId = (apiRequestCallId: string) => {
    const excludedApiCalls = [
      this.getPaymentMethodsApiCallId,
      this.getCatalogueListApiId,
      this.getTemporaryProductListApiId,
      this.getStoreListApiId,
      this.updateEmployeeCurrentStoreApiId,
      this.createOrderApiCallID,
      this.updateOrderApiCallID,
      this.getPreferencesDataApiCallId,
    ];

    return !excludedApiCalls.includes(apiRequestCallId);
  };

  // API response handling start
  handleResponse = (message: Message) => {
    let apiRequestCallId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );

    if (this.handleCheckApiCallWithId(apiRequestCallId)) return true;
    let responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );
    let errorReponse = message.getData(
      getName(MessageEnum.RestAPIResponceErrorMessage)
    );
    if (
      !apiRequestCallId ||
      !responseJson ||
      responseJson?.errors ||
      responseJson?.error
    ) {
      this.handleErrorResponse(apiRequestCallId, responseJson, errorReponse);
      return;
    }
    switch (apiRequestCallId) {
      case this.getPaymentMethodsApiCallId:
        this.handlePaymentMethodsResponse(responseJson);
        break;
      case this.getCatalogueListApiId:
        this.handleCatalogueListResponse(responseJson);
        break;
      case this.getTemporaryProductListApiId:
        this.setState({
          cataloguesList: [...responseJson.data, ...this.state.cataloguesList],
          temporaryProducts: responseJson.data,
        });
        break;
      case this.getStoreListApiId:
        this.handelStoreListResponse(responseJson);
        break;
      case this.updateEmployeeCurrentStoreApiId:
        localStorage.setItem(
          "store_id",
          responseJson.data?.attributes.store_management_id
        );
        this.handleSendAction("CLEAR_CUSTOMER_CART", null);
        this.state.userRefresh();
        break;
      case this.createOrderApiCallID:
      case this.updateOrderApiCallID:
        this.handleOrderProcessing(responseJson);
        break;
      case this.getPreferencesDataApiCallId:
        this.handleCreateNewOrder(null);
        break;
    }
  };

  handleOrderProcessing = (responseJson: any) => {
    if (responseJson.status === 422) {
      this.setState({
        errorSnackbarOpen: true,
        errorMessage: responseJson.message,
      });
    }
    this.handleOrderResponse(responseJson);
  };

  handelStoreDropdownScroll = (event: React.SyntheticEvent) => {
    if (this.storeListEmptyFlag) return;
    const listboxNode = event.currentTarget;
    const position = listboxNode.scrollTop + listboxNode.clientHeight;

    if (listboxNode.scrollHeight - position <= 1.3) {
      this.setState(
        (prev) => ({ storeListPageNo: prev.storeListPageNo + 1 }),
        () => {
          this.getStoreList();
        }
      );
    }
  };


  handleErrorResponse = (
    apiRequestCallId: any,
    responseJson: any,
    errorResponse: any
  ) => {
    this.orderTimeout = undefined;
    if (typeof responseJson?.errors !== "string") {
      this.setState({
        errorMessage: conditionalString(
          responseJson?.errors?.length,
          conditionalString(
            typeof responseJson.errors[0] === "string",
            responseJson.errors[0],
            lodash.toString(responseJson.errors[0]?.message)
          ),
          lodash.toString(responseJson.message)
        ),
        errorSnackbarOpen: true,
      });
    } else {
      this.setState(
        {
          isLoading: false,
          errorMessage:
            typeof responseJson?.errors === "string" &&
            responseJson.status !== 500
              ? responseJson?.errors
              : "Internal server error",
          snackbarSeverity: "error",
        },
        () => this.setState({ errorSnackbarOpen: true })
      );
    }

    if (
      apiRequestCallId === this.updateOrderApiCallID ||
      apiRequestCallId === this.createOrderApiCallID
    ) {
      this.handleSendAction("SET_ORDER", this.state.laundryOrder);
      this.setState({
        cartProducts: this.state.cartProducts.filter(
          (cartProduct) => cartProduct.id !== undefined
        ),
        cartsItemsPreferencesData: [],
      });
    }

    this.handleCatalogueListErrorResponse(apiRequestCallId, responseJson);
    this.handleSendAction("SHOPPING_CART_LOADING", false);
    this.setState({ isLoading: false });
  };

  handleCatalogueListErrorResponse = (
    apiRequestCallId: string,
    responseJson: any
  ) => {
    if (apiRequestCallId === this.getCatalogueListApiId) {
      this.setState({ cataloguesList: [], isCatalogueCardLoading: false });
    }
    if (apiRequestCallId === this.updateOrderApiCallID) {
      this.setState({
        errorSnackbarOpen: true,
        errorMessage: responseJson.message ?? responseJson.errors,
      });
      if (responseJson.is_load) {
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      }
    }
  };


  handleOrderResponse(responseJson: {
    data: { id: number; attributes: IlaundryOrder };
  }) {
    const orderId = responseJson?.data?.id;
    const orderAttributes = responseJson?.data?.attributes;
    const laundryItems = orderAttributes?.items?.data || [];

    const laundryOrder = {
      ...orderAttributes,
      id: orderId,
    };
    if (this.state.isClearCartActionCall) {
      this.setState({
        laundryOrder: null,
        laundryOrderItems: [],
        cartProducts: [],
        selectedProductQuantity: {},
        selectedCustomer: null,
        editSelectedCustomer: null,
        customerData: undefined,
        customerId: null,
        saveForFuture: false,
        isPopuDisabledWithOrderCreate: false,
        isLoading: false,
        isClearCartActionCall: false,
      });

      this.handleSendAction("SET_ORDER", null);
      this.handleSendAction("CLEAR_CUSTOMER");
      this.handleSendAction("SHOPPING_CART_LOADING", false);
      return;
    }

    const updatedCartProducts = this.state.cartProducts.map((cartProduct) => {
      const matchedItem = laundryItems.find(
        (item: any) =>
          Number(item.attributes.golden_point.id) ===
          Number(cartProduct.catalogue_id)
      );
      return {
        ...cartProduct,
        id: matchedItem ? Number(matchedItem.id) : cartProduct.id,
        quantity: matchedItem
          ? matchedItem.attributes.quantity
          : cartProduct.quantity,
      };
    });

    const selectedProductQuantity: Record<string, number> = {};

    laundryItems.forEach((item: any) => {
      selectedProductQuantity[item.attributes.golden_point.id] =
        item.attributes.quantity;
    });

    this.setState({
      laundryOrder,
      laundryOrderItems: laundryItems,
      cartProducts: updatedCartProducts,
      selectedProductQuantity,
      isPopuDisabledWithOrderCreate: false,
      isLoading: false,
    });

    this.handleSendAction("SET_ORDER", laundryOrder);
    this.handleClearCartActionCalled();
    this.handleSendAction("SHOPPING_CART_LOADING", false);
  }


  handleClearCartActionCalled = () => {
    const { isClearCartActionCall, editId } = this.state;
    if (isClearCartActionCall && !editId) {
      this.handleSendAction("CLEAR_CUSTOMER");
    }

    this.setState({ isClearCartActionCall: false });
  };

  handelStoreListResponse(responseJson: { data: Store[] }) {
    const { userData, storeListPageNo, storeList } = this.state;
    const { store_id, store_name } =
      userData?.attributes?.employee_proifle?.data?.attributes
        ?.store_management || {};
    let currentStore = storeList.find(
      (store) => store.id === lodash.toString(store_id)
    );
    if (store_id !== undefined && currentStore === undefined) {
      currentStore = {
        id: lodash.toString(store_id),
        option: lodash.toString(store_name),
      };
    }
    const array = (responseJson?.data || []).map((item) => ({
      id: item.id,
      option: item.attributes.store_name,
    }));
    const newStoreList =
      storeListPageNo === 1 ? array : [...storeList, ...array];
    currentStore && newStoreList.unshift(currentStore);
    this.storeListEmptyFlag = array.length < 10;
    this.setState({
      storeList: lodash.uniqBy(newStoreList, "id"),
    });
  }

  handleCatalogueListResponse = (responseJson: {
    data: CatalogueList[];
    meta: Meta;
  }) => {
    const today = new Date();
    const filteredData = responseJson.data.filter((item: any) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const start = new Date(item.attributes.purchase_start_date);
      start.setHours(0, 0, 0, 0);

      const end = item.attributes.purchase_end_date
        ? new Date(item.attributes.purchase_end_date)
        : null;
      if (end) end.setHours(0, 0, 0, 0);

      const isAfterStart = today >= start;
      const isBeforeEnd = end ? today <= end : true;

      return isAfterStart && isBeforeEnd;
    });
    this.setState((prevState) => ({
      cataloguesList:
        prevState.currentPage > 1
          ? [...prevState.cataloguesList, ...filteredData]
          : [...filteredData],

      catalogueListEmptyFlag: filteredData.length === 0,
      cataloguesListMeta: responseJson.meta,
      isCatalogueCardLoading: false,
      highlightedSectionIds: [],
    }));
  };


  redirectToSectionTab = (value: number) => {
    this.setState({ tabsId: value, cataloguesList: [] }, () => {
      this.getCatalogueList(1);
    });
  };

  // api calling start
  getStoreList = () => {
    const searchQuery = this.state.storeSearchText
      ? `&filter_by[query]=${this.state.storeSearchText}`
      : "";
    const apiUrl =
      configJSON.getStoreListApi +
      `?dropdown=true${searchQuery}&page_no=${this.state.storeListPageNo}`;

    const requestMessage = makeApiMessage({
      url: apiUrl,
      method: configJSON.apiMethodTypeGet,
    });

    this.storeListEmptyFlag = true;
    this.getStoreListApiId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  getCatalogueList = (page: number = this.state.currentPage) => {
    this.setState({ isCatalogueCardLoading: true });
    const { userCustomerPriceList, userCustomerPriceListId, userData } =
      this.state;
    const store_management =
      userData?.attributes?.employee_proifle?.data?.attributes?.store_management
        ?.attributes;
    const priceId = userCustomerPriceList
      ? userCustomerPriceListId
      : store_management?.price_list_id;

    const filterSearch = this.state.searchText
      ? `&filter_by[name]=${this.state.searchText}`
      : "";

    const sectionIds = store_management?.sections?.length
      ? store_management.sections.map((section) => section.id).join(",")
      : "";

    const storeManagementId = store_management?.id; // <-- Get store_management_id

    if (!sectionIds) {
      this.setState({ isCatalogueCardLoading: false, cataloguesList: [] });
      return;
    }

    const apiUrl =
      configJSON.getGoldenPointListDataApi +
      `?&per_page=100&page_no=${page}${filterSearch}&pos=true&allow_access=true&store_management_id=${storeManagementId}`;

    const requestMessage = makeApiMessage({
      url: apiUrl,
      method: configJSON.apiMethodTypeGet,
    });

    this.getCatalogueListApiId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  updateEmployeeCurrentStore = (storeId: number) => {
    const bodyData = {
      store_id: storeId,
    };

    const apiUrl = configJSON.updateEmployeeCurrentStoreApi;

    const requestMessage = makeApiMessage({
      url: apiUrl,
      method: configJSON.apiMethodTypePut,
      body: JSON.stringify(bodyData),
    });

    this.updateEmployeeCurrentStoreApiId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };
  // api calling end

  getOrderTypeList = () => {
    const { enableHomeCleaningSettings } = this.state;
    const Strings = configJSON.Strings;

    let orderTypes = [
      { label: Strings.plant_cleaning, value: ORDER_TYPES.STORE_ORDER },
      // { label: Strings.plant_tab, value: ORDER_TYPES.PLANT_ORDER }
    ];

    if (enableHomeCleaningSettings) {
      orderTypes.push({
        label: Strings.home_cleaning_tab,
        value: ORDER_TYPES.CLEANING_ORDER,
      });
    }
    return orderTypes;
  };

  getOrderRenderBasedOnOrderType = (
    trueValue: React.ReactNode,
    falseValue: React.ReactNode
  ) => {
    const condition = [
      ORDER_TYPES.CLEANING_ORDER,
      ORDER_TYPES.PLANT_ORDER,
    ].includes(this.state.selectedMainTab);
    return condition ? trueValue : falseValue;
  };

  tabSectionChangeHandler = (
    _event: React.ChangeEvent<{}>,
    newValue: number
  ) => {
    this.setState({ tabsId: newValue, cataloguesList: [] }, () => {
      this.getCatalogueList(1);
    });
  };

  handleDisanledPopupAPIcall = (updateBody?: UpdateGoldenPointOrderBody) => {
    const { laundryOrder, isPopuDisabledWithOrderCreate } = this.state;
    if (isPopuDisabledWithOrderCreate) {
      if (laundryOrder?.id) {
        this.handleUpdateOrderAPI(updateBody || null);
      } else {
        this.handleCreateNewOrder(null);
      }
    }
  };

  resetForm = () => {};

  handleStoreChange = () => {
    this.handleResetCartCustomerPhone();
  };
  handleResetCartCustomerPhone = () => {
    this.setState({
      cartProducts: [],
      cartTotalOpen: false,
      customerId: null,
      customerData: undefined,
      orderNotes: "",
      saveForFuture: false,
      paymentMethod: "",
      tabsId: 0,
    });
    this.resetForm();
  };

  handleCatalogueListScroll = (event: React.SyntheticEvent) => {
    const target = event.target as HTMLElement;
    const position = target.scrollTop + target.clientHeight;
    if (
      !this.state.isCatalogueCardLoading &&
      target.scrollHeight - position <= 1.3 &&
      !this.state.catalogueListEmptyFlag
    ) {
      this.setState({ currentPage: this.state.currentPage + 1 }, () =>
        this.getCatalogueList()
      );
    }
  };

  handleCloseSubProductDialog = () => {
    this.setState((prevState) => ({
      subProductModalOpen: false,
      clickedParentCatalougeId: null,
      cartProducts: lodash.cloneDeep(prevState.beforePopupCartProducts),
      beforePopupCartProducts: [],
    }));
  };

  handleSubmitSubProductDialog = () => {
    this.setState({
      subProductModalOpen: false,
      clickedParentCatalougeId: null,
      beforePopupCartProducts: [],
    });
  };

  addQuantityClickHandler = (params: { catalogue: CatalogueList }) => {
    const catalogue = params.catalogue;
    const { cartProducts, selectedProductQuantity } = this.state;
    const canProceed = this.serviceClickHandler({ catalogue });
    if (!canProceed) return;

    const tempCartProduct = [...cartProducts];
    const selectedProductIndex = tempCartProduct.findIndex(
      (product) => product.catalogue_id === catalogue.attributes.id
    );

    const laundryItems = this.state.laundryOrder?.items?.data || [];
    const matchedLaundryItem = laundryItems.find(
      (item: any) =>
        Number(item.attributes.golden_point.id) ===
        Number(catalogue.attributes.id)
    );
    const itemIdFromLaundry = matchedLaundryItem
      ? Number(matchedLaundryItem.id)
      : undefined;
    if (selectedProductIndex === -1) {
      const newProductInCart: ICartProductItem = {
        id: itemIdFromLaundry,
        catalogue_id: catalogue.attributes.id,
        name: catalogue.attributes.name,
        total_points: catalogue.attributes.total_points ?? 0,
        start_date_base: catalogue.attributes.start_date_base ?? null,
        end_date_base: catalogue.attributes.end_date_base ?? null,
        price: catalogue.attributes.price ?? 0,
        final_price: catalogue.attributes.final_price ?? 0,
        free_wash_quentity: catalogue.attributes.free_wash_quentity ?? 0,
        base_points: catalogue.attributes.base_points ?? 0,
        bonus_points: catalogue.attributes.bonus_points ?? 0,
        golden_point_text_en: catalogue.attributes.golden_point_text_en ?? "",
        free_wash_description: catalogue.free_wash_description,
        unit_price: 0,
        quantity: 1,
        order_item_id: 0
      };
      tempCartProduct.push(newProductInCart);
      this.setState({ cartProducts: tempCartProduct });
    } else {
      const existingProduct = tempCartProduct[selectedProductIndex];
      existingProduct.quantity = (existingProduct.quantity || 0) + 1;
      this.setState({ cartProducts: tempCartProduct });
      this.updateQtyApicall(existingProduct);
    }
    const catalogueId = String(catalogue.attributes.id);
    const newSelectedQty = (selectedProductQuantity[catalogueId] || 0) + 1;

    this.setState({
      selectedProductQuantity: {
        ...selectedProductQuantity,
        [catalogueId]: newSelectedQty,
      },
    });
  };

  removeQuantityClickHandler = (params: { catalogue: CatalogueList }) => {
    const catalogue = params.catalogue;
    const { tabsId, cartProducts, selectedProductQuantity } = this.state;
    const tempCartProduct = [...cartProducts];
    let selectedProductData = this.getCatalogueDataBasedOnCondition(
      Number(catalogue.attributes.id)
    );
    const selectedProductIndex = tempCartProduct.findIndex(
      (product) => product.catalogue_id === catalogue.attributes.id
    );

    if (tempCartProduct[selectedProductIndex].quantity == 0) {
      return;
    } else {
      tempCartProduct[selectedProductIndex].quantity =
        tempCartProduct[selectedProductIndex].quantity - 1;
      this.updateQtyApicall(tempCartProduct[selectedProductIndex]);
      if (tempCartProduct[selectedProductIndex].quantity == 0) {
        tempCartProduct.splice(selectedProductIndex, 1);
      }
    }
    const catalogueId = String(catalogue.attributes.id);
    // const newSelectedQty = (selectedProductQuantity[catalogueId] || 0) + 1;
    const newSelectedQty = Math.max((selectedProductQuantity[catalogueId] || 0) - 1, 0 );
    this.setState({
      cartProducts: tempCartProduct,
      selectedProductQuantity: {
        ...selectedProductQuantity,
        [catalogueId]: newSelectedQty,
      },
    });
  };





  handleOnUserChange = async (userContext: IUserContext) => {
    const { attributes } =
      userContext?.user?.attributes?.employee_proifle?.data?.attributes
        ?.store_management || {};
    const { is_process_cleaning_products } = attributes || {};
    const accountType = await getStorageData("accountType");
    const isB2bActive = accountType === "b2b";

    this.setState(
      {
        enableHomeCleaningSettings:
          String(is_process_cleaning_products) == "true",
        userData: userContext?.user,
        userRefresh: userContext?.refreshUser,
        tabsId: userContext?.user?.attributes?.employee_proifle?.data
          ?.attributes?.store_management?.attributes?.sections?.[0]
          ?.id as number,
        storeListPageNo: 1,
        isB2bActive,
      },
      () => {
        this.getStoreList();
        this.getCatalogueList();
      }
    );

    const apiKey = customPermissionApiKey.orderPermission;
    const userData = userContext.user?.attributes.permission_groups;
    const value = checkForNewPermissonStatus(
      apiKey,
      userData as Array<PermissionGroupArray>
    );
    const b2bPermission = checkForNewPermissonStatus(
      customPermissionApiKey.b2BOrderPermission,
      userData as Array<PermissionGroupArray>
    );
    this.setState({
      permissionStatus: {
        ...value,
        ...(isB2bActive
          ? {
              createPermission: b2bPermission.createPermission,
              viewPermission: b2bPermission.viewPermission,
              editPermission: b2bPermission.editPermission,
            }
          : {}),
      },
    });
  };

  handleSearch = (value: string) => {
    this.setState(
      {
        currentPage: 1,
        searchText: value,
      },
      () => {
        ORDER_TYPES.STORE_ORDER == this.state.selectedMainTab &&
          this.getCatalogueList(1);
      }
    );
  };

  handleSearchStore = (inputValue: string) => {
    if (inputValue === this.state.storeSearchText) return;
    this.setState(
      {
        storeListPageNo: 1,
        storeSearchText: inputValue,
      },
      () => this.getStoreList()
    );
  };

  debouncedStoreSearch = lodash.debounce(
    (newInputValue: string) => this.handleSearchStore(newInputValue),
    700,
    { maxWait: 2000 }
  );

  handleReturnIndexOfCatalogue = (
    catalogue: CatalogueList,
    tempCartProduct: ICartProductItem[]
  ) => {
    const { tabsId } = this.state;
    const selectedCatalogueIndex = tempCartProduct.findIndex(
      (product) => product.catalogue_id === catalogue.attributes.id
      // &&
      //   product.category_id === tabsId
    );
    return selectedCatalogueIndex;
  };

  serviceClickHandler = (params: { catalogue: CatalogueList }): boolean => {
    const { catalogue } = params;
    const {
      selectedCustomer,
      editSelectedCustomer,
      editId,
      laundryOrder,
      cartProducts,
    } = this.state;
    const validCustomer = !editId ? selectedCustomer : editSelectedCustomer;
    if (!validCustomer) {
      this.setState({
        errorMessage: "Please select a customer",
        errorSnackbarOpen: true,
      });
      return false;
    }
    const customer_Id = validCustomer.id ?? null;

    const updateOrderData: UpdateGoldenPointOrderBody = {
      customer_id: String(customer_Id ?? ""),
      golden_point_items_attributes: [
        {
          golden_point_id: Number(catalogue.id),
          quantity: Number(
            cartProducts?.find((p) => p.catalogue_id === Number(catalogue.id))
              ?.quantity ?? 1
          ),
        },
      ],
    };

    if (laundryOrder?.id) {
      this.handleUpdateOrderAPI(updateOrderData);
    } else {
      this.handleCreateNewOrder(updateOrderData);
    }

    this.setState({
      preferenceModalVisible: true,
    });
    return true;
  };

  editQuickDropSelectCust = (message: Message) => {
    const payload = message.getData(
      getCustomEnumName(CustomEnums.CustomReducerPayload)
    );
    if (payload) {
      const isOrderItems = payload ? payload.order_items : [];

      localStorage.setItem("orderId", payload.id);
      const isB2bOrder = !payload.account_id;
      const shouldFetchCatalogue =
        isB2bOrder || isB2bOrder !== this.state.isB2bActive;
      this.setState(
        {
          editId: true,
          selectedCustomer: payload.customer,
          editSelectedCustomer: payload.customer,
          laundryOrder: payload,
          StoreOrderItem: isOrderItems,
          isB2bActive: isB2bOrder,
        },
        () => {
          if (this.state.userData?.attributes && shouldFetchCatalogue) {
            this.getCatalogueList();
          }
        }
      );
    }
  };

  handleCustomReducer = (message: Message) => {
    const action = message.getData(
      getCustomEnumName(CustomEnums.CustomReducerAction)
    );
    const payload = message.getData(
      getCustomEnumName(CustomEnums.CustomReducerPayload)
    );

    const value = payload ? payload : null;
    switch (action) {
      case "SELECT_CUSTOMER":
        if (payload) {
          const goldenOrders = payload.attributes.golden_point_orders || [];
          if (goldenOrders.length > 0) {
            const firstOrder = goldenOrders[0];
            const cartItems =
              firstOrder?.items?.data?.map((item: any) => ({
                id: Number(item.id),
                catalogue_id: Number(item.attributes.golden_point?.id),
                order_item_id: Number(item.id),
                name: item.attributes.golden_point?.name,
                total_points: item.attributes.golden_point?.total_points ?? 0,
                start_date_base:
                  item.attributes.golden_point?.start_date_base ?? null,
                end_date_base:
                  item.attributes.golden_point?.end_date_base ?? null,
                price: item.attributes.golden_point?.price ?? 0,
                final_price: item.attributes.golden_point?.final_price ?? 0,
                free_wash_quentity:
                  item.attributes.golden_point?.free_wash_quentity ?? 0,
                base_points: item.attributes.golden_point?.base_points ?? 0,
                bonus_points: item.attributes.golden_point?.bonus_points ?? 0,
                golden_point_text_en:
                  item.attributes.golden_point?.golden_point_text_en ?? "",
                free_wash_description:
                  item.attributes.golden_point?.free_wash_description ?? "",
                unit_price: 0,
                quantity: Number(item.attributes.quantity ?? 1),
              })) || [];
            this.setState({
              selectedCustomer: value,
              laundryOrderItems: [],
              StoreOrderItem: [],
              laundryOrder: firstOrder,
              cartProducts: cartItems,
              isLoading: false,
              cartsItemsPreferencesData: firstOrder.items.data.map(
                (item: any) => ({
                  customer_preference_id:
                    item.attributes.customer_preference_id,
                  catalogue_variant_id: item.attributes.catalogue_variant_id,
                  service_id: item.attributes.service_id,
                })
              ),
            });
          } else {
            this.setState({
              selectedCustomer: value,
              laundryOrder: null,
              laundryOrderItems: [],
              StoreOrderItem: [],
              cartsItemsPreferencesData: [],
              cartProducts: [],
              isLoading: false,
            });
          }
        } else {
          this.handleSelectCustomerWithoutPayload();
        }
        break;
      case "EDIT_SELECT_CUSTOMER":
        this.editQuickDropSelectCust(message);
        break;
      case "SET_ORDER":
        if (payload) {
          localStorage.setItem("orderId", payload.id);
        }
        this.setState(
          {
            laundryOrder: value,
            StoreOrderItem: payload ? payload.items : [],
          },
          () => this.handleQuickdropAndlundryorder()
        );
        break;
      case "DELETE_CART_PRODUCT":
        this.deleteOrderItemHandler(payload);
        break;
      case "UPDATE_CART_QTY":
        this.updateCartQtyApicall(payload);
        break;
      case "CLEAR_CART":
        this.handleClearAllCart();
        break;
      case "ADD_CUSTOM_QTY":
        this.handleCustomInpputQty(payload);
        break;
    }
  };

  handleSelectCustomerWithoutPayload = () => {
    // remove temprory products if added when no customer selected
    const { cataloguesList, temporaryProducts } = this.state;
    const temporaryProductsIds = temporaryProducts.map((tempProduct) =>
      Number(tempProduct.id)
    );
    const catalogueListWithoutTempProducts = cataloguesList.filter(
      (catalogue) => !temporaryProductsIds.includes(Number(catalogue.id))
    );
    this.setState(
      {
        selectedCustomer: null,
        laundryOrder: null,
        StoreOrderItem: [],
        cataloguesList: this.state.isB2bActive
          ? []
          : catalogueListWithoutTempProducts,
        temporaryProducts: [],
        userCustomerPriceListId: null,
        userCustomerPriceList: false,
        currentPage: 1,
      },
      () => {
        this.getCatalogueList();
        this.handleQuickdropAndlundryorder();
      }
    );
  };

  handleQuickdropAndlundryorder = () => {
    const { laundryOrder, StoreOrderItem } = this.state;
    // if (laundryOrder?.is_quick_drop && laundryOrder.order_items.length > 0) {
    //   this.setState({
    //     isQuickDrop: true,
    //   });
    // } else {
    this.setState({
      isQuickDrop: false,
    });
    // this.handlePreCustomerOrder(laundryOrder);
    // }
  };

  handlePreCustomerOrder = (orderItems: Array<StoreOrderItem>) => {
    if (orderItems.length > 0) {
      const tempCart = orderItems.map((item) => {
        const gp = item.attributes.golden_point?.attributes;
        return {
          id: item.attributes.id ?? undefined,
          catalogue_id: item.attributes.catalogue?.id ?? 0,
          name: gp?.name ?? "",
          order_item_id : item.attributes.id ?? undefined,
          unit_price: Number(item.attributes.unit_price ?? 0),
          quantity: item.attributes.quantity ?? 1,
          notes: item.attributes.notes ?? undefined,
          total_points: String(
            gp?.total_points ?? item.attributes.total_points ?? 0
          ), // convert to string
          start_date_base: String(
            gp?.start_date_base ?? item.attributes.start_date_base ?? ""
          ),
          end_date_base: String(
            gp?.end_date_base ?? item.attributes.end_date_base ?? ""
          ),
          price: String(gp?.price ?? item.attributes.price ?? 0),
          free_wash_quentity: String(
            gp?.free_wash_quentity ?? item.attributes.free_wash_quentity ?? 0
          ),
          free_wash_description: item.attributes.free_wash_description ?? "",
          final_price: String(
            gp?.final_price ?? item.attributes.final_price ?? 0
          ),
          bonus_points: String(
            gp?.bonus_points ?? item.attributes.bonus_points ?? 0
          ),
          golden_point_text_en:
            gp?.golden_point_text_en ??
            item.attributes.golden_point_text_en ??
            "",
          base_points: String(
            gp?.base_points ?? item.attributes.base_points ?? 0
          ),
          name_arabic: gp?.name_arabic ?? "",
          golden_point_text_ar: gp?.golden_point_text_ar ?? "",
        };
      });
      this.setState({ cartProducts: tempCart });
    } else {
      this.setState({ cartProducts: [] });
    }
  };

  getProductPreferencesCall = (
    catalogue_variant_id: number
    // service_id: number
  ) => {
    const { selectedCustomer, userData } = this.state;
    const store_id =
      userData?.attributes.employee_proifle.data.attributes.store_management_id;
    const apiUrl =
      configJSON.getProductPreferences +
      `?customer_id=${
        selectedCustomer?.id
      }&catalogue_variant_id=${catalogue_variant_id}&service_id=${""}&allow_access=true&store_id=${store_id}${
        this.state.isB2bActive ? "&request_type=B2b" : ""
      }`;
    let message = makeApiMessage({
      url: apiUrl,
      method: "GET",
    });
    this.getPreferencesDataApiCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  handleSnackbarClose = () => {
    this.setState({
      errorSnackbarOpen: false,
      errorMessage: "",
      snackbarSeverity: "warning",
    });
  };

  getUpdateOrderBody = (params: UpdateGoldenPointOrderBody | null) => {
    const { selectedCustomer, cartProducts, userData, isB2bActive } =
      this.state;
    const customerField = isB2bActive
      ? {
          business_account_customer_id: (selectedCustomer as CustomerDataType)
            .id,
        }
      : { customer_id: (selectedCustomer as CustomerDataType).id };
    const goldenPointItems = params?.golden_point_items_attributes?.length
      ? params.golden_point_items_attributes.map((gp) => ({
          golden_point_id: Number(gp.golden_point_id),
          quantity: Number(gp.quantity),
        }))
      : cartProducts.map((item) => ({
          id: Number(item.id),
          golden_point_id: Number(item.catalogue_id),
          quantity: Number(item.quantity),
        }));

    const updateBody = {
      data: {
        ...customerField,
        // is_quick_drop: true,
        store_management_id:
          userData?.attributes?.employee_proifle?.data?.attributes
            ?.store_management_id,

        golden_point_items_attributes: goldenPointItems.filter(
          (item) =>
            item.golden_point_id !== undefined &&
            !Number.isNaN(item.golden_point_id) &&
            item.quantity > 0
        ),
      },
    };

    return updateBody;
  };

  getCreateOrderBody = (params: UpdateGoldenPointOrderBody | null) => {
    const { selectedCustomer, cartProducts, userData, isB2bActive } =
      this.state;
    // Determine which customer field to use (B2B or B2C)
    const customerField = isB2bActive
      ? {
          business_account_customer_id: (selectedCustomer as CustomerDataType)
            .id,
        }
      : { customer_id: (selectedCustomer as CustomerDataType).id };
    const goldenPointItems = params?.golden_point_items_attributes?.length
      ? params.golden_point_items_attributes.map((gp) => ({
          golden_point_id: Number(gp.golden_point_id),
          quantity: Number(gp.quantity),
        }))
      : cartProducts.map((item) => ({
          id: Number(item.id),
          golden_point_id: Number(item.catalogue_id),
          quantity: Number(item.quantity),
        }));

    const updateBody = {
      data: {
        ...customerField,
        // is_quick_drop: true,
        store_management_id:
          userData?.attributes?.employee_proifle?.data?.attributes
            ?.store_management_id,

        golden_point_items_attributes: goldenPointItems.filter(
          (item) =>
            item.golden_point_id !== undefined &&
            !Number.isNaN(item.golden_point_id) &&
            item.quantity > 0
        ),
      },
    };
    return updateBody;
  };

  handleUpdateOrderAPI = (params: UpdateGoldenPointOrderBody | null) => {
    this.handleSendAction("SHOPPING_CART_LOADING", true);
    const { laundryOrder } = this.state;
    let message = makeApiMessage({
      url: this.state.isB2bActive
        ? `${configJSON.bussinessUpdateOrderEndPoint}?id=${
            (laundryOrder as IlaundryOrder).id
          }`
        : configJSON.actionOrderByIdEndpoint +
          (laundryOrder as IlaundryOrder).id,
      body: JSON.stringify(this.getUpdateOrderBody(params)),
      method: "PUT",
    });
    this.updateOrderApiCallID = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  handleCreateNewOrder = (params: UpdateGoldenPointOrderBody | null) => {
    this.handleSendAction("SHOPPING_CART_LOADING", true);
    //   if (params) {
    //   params.golden_point_items_attributes = [
    //     { golden_point_id: 11, quantity: 2 },
    //     { golden_point_id: 10, quantity: 1 },
    //   ];
    // } else {
    //   // If params is null, you can initialize it
    //   params = {
    //     golden_point_items_attributes: [
    //       { golden_point_id: 11, quantity: 2 },
    //       { golden_point_id: 10, quantity: 1 },
    //     ],
    //   } as UpdateGoldenPointOrderBody;
    // }
    const apiEndPoint = this.state.isB2bActive
      ? configJSON.bussinessCreateNewOrderEndpoint
      : configJSON.createNewOrderEndpoint;

    let message = makeApiMessage({
      url: apiEndPoint,
      body: JSON.stringify(this.getCreateOrderBody(params)),
      method: "POST",
    });
    this.createOrderApiCallID = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  updateQtyApicall(cartItem: ICartProductItem) {
    const { laundryOrder, selectedCustomer, isB2bActive, cartProducts } =
      this.state;

    if (!selectedCustomer) {
      console.warn("No customer selected, cannot update order.");
      return;
    }
    if (!laundryOrder) {
      console.warn("No laundry order available, cannot update order.");
      return;
    }
    if (!cartItem.catalogue_id) {
      console.warn("cartItem.catalogue_id is missing", cartItem);
      return;
    }
    const customer_Id = isB2bActive
      ? { business_account_customer_id: selectedCustomer.id }
      : { customer_id: selectedCustomer.id };
    const putBody = {
      data: {
        ...customer_Id,
        store_management_id: laundryOrder.store_management_id,
        // golden_point_items_attributes: goldenPointItems.filter(
        //   (item) =>
        //     item.golden_point_id !== undefined &&
        //     !Number.isNaN(item.golden_point_id) &&
        //     item.quantity > 0
        // ),
        golden_point_items_attributes: [
          {
            golden_point_id: cartItem.catalogue_id,
            quantity: cartItem.quantity,
            _destroy: cartItem.quantity === 0,
          },
        ],
      },
    };
    const goldenPoints =
      laundryOrder?.items?.data?.map(
        (item: any) => item?.attributes?.golden_point?.attributes
      ) ?? [];

    const firstGP = goldenPoints[0];
    const url = configJSON.actionOrderByIdEndpoint + laundryOrder.id;
    const message = makeApiMessage({
      url,
      body: JSON.stringify(putBody),
      method: "PUT",
    });
    this.updateOrderApiCallID = message.messageId;
    runEngine.sendMessage(message.id, message);
  }


  updateCartQtyApicall(cartItem: StoreOrderItem) {
    this.handleSendAction("SHOPPING_CART_LOADING", true);
    const { laundryOrder, selectedCustomer } = this.state;
    const customer_Id = this.state.isB2bActive
      ? {
          business_account_customer_id: (selectedCustomer as CustomerDataType)
            .id,
        }
      : { customer_id: (selectedCustomer as CustomerDataType).id };
    const putBody = {
      data: {
        ...customer_Id,
        store_management_id: laundryOrder?.store_management_id,
        golden_point_items_attributes: [
          {
            id: cartItem.id,
            quantity: cartItem.attributes.quantity,
            _destroy: cartItem.attributes.quantity == 0 ? true : false,
          },
        ],
      },
    };
    let qtymessage = makeApiMessage({
      url: configJSON.actionOrderByIdEndpoint + cartItem.id,
      body: JSON.stringify(putBody),
      method: "PUT",
    });
    this.updateOrderApiCallID = qtymessage.messageId;
    runEngine.sendMessage(qtymessage.id, qtymessage);
  }


  handleSendAction(action: string, payload?: unknown) {
    let message = new Message(
      getCustomEnumName(CustomEnums.CustomActionReducers)
    );
    message.addData(getCustomEnumName(CustomEnums.CustomReducerAction), action);
    message.addData(
      getCustomEnumName(CustomEnums.CustomReducerPayload),
      payload
    );
    runEngine.sendMessage(message.id, message);
  }

  deleteOrderItemHandler(data: StoreOrderItem) {
    this.handleSendAction("SHOPPING_CART_LOADING", true);
    const { cartProducts } = this.state;
    const tempCartProduct = [...cartProducts];
    const selectedProductIndex = tempCartProduct.findIndex((product) => {
      if (product.catalogue_id) {
        return Number(product.catalogue_id) === Number(data.id);
      }
      const itemsData = product.items?.data ?? [];
      return itemsData.some(
        (item) => Number(item.attributes.catalogue.id) === Number(data.id)
      );
    });
    let selectedItem =
      selectedProductIndex !== -1
        ? tempCartProduct[selectedProductIndex]
        : null;

      if (selectedItem) {
        selectedItem = {
          ...selectedItem,
          order_item_id:
            selectedItem.order_item_id && selectedItem.order_item_id > 0
              ? selectedItem.order_item_id
              : (data.order_item_id ?? 0),
          id:
            selectedItem.id ?? data.order_item_id ?? 0,
        };
      }
    const updatedCart = tempCartProduct.filter((product) => {
      if (product.catalogue_id) {
        return Number(product.catalogue_id) !== Number(data.id);
      }

      const itemsData = product.items?.data ?? [];
      return !itemsData.some(
        (item) => Number(item.attributes.catalogue.id) === Number(data.id)
      );
    });
    this.setState({ cartProducts: updatedCart });

    if (selectedItem) {
      this.deleteOrderItemApicall(selectedItem);
    }
  }

  deleteOrderItemApicall(cartItem: ICartProductItem,ItemId?: number) {
    const { laundryOrder, selectedCustomer } = this.state;
    const customer_Id = this.state.isB2bActive
      ? {
          business_account_customer_id: (selectedCustomer as CustomerDataType)
            .id,
        }
      : { customer_id: (selectedCustomer as CustomerDataType).id };
    let orderItemId: number | undefined;
      if (cartItem.order_item_id) {
        orderItemId = Number(cartItem.order_item_id);
      } else if ((cartItem.items?.data?.length ?? 0) > 0) {
        orderItemId = Number(cartItem.items?.data?.[0]?.id);
      } else if (cartItem.id) {
        orderItemId = Number(cartItem.id);
      }

    if (!orderItemId) {
      console.warn("No order item id found to delete");
      return;
    }
    const putBody = {
      data: {
        ...customer_Id,
        store_management_id: laundryOrder?.store_management_id,
        order_items_attributes: [
          {
            id: orderItemId,
            _destroy: true,
          },
        ],
      },
    };

    let message = makeApiMessage({
      url: configJSON.deleteOrderByIdEndpoint,
      body: JSON.stringify(putBody),
      method: "PUT",
    });
    this.resetProductQuantity(cartItem.catalogue_id);
    this.updateOrderApiCallID = message.messageId;
    runEngine.sendMessage(message.id, message);
  }

  resetProductQuantity(catalogueId: number) {
    const updatedCart = this.state.cartProducts.filter(
      (item: ICartProductItem) => {
        return item.catalogue_id !== catalogueId;
      }
    );

    this.setState({ cartProducts: updatedCart });
  }

  handleClearAllCart() {
    // this.setState({ isClearCartActionCall: true });
    this.setState({
      isClearCartActionCall: true,
      cartProducts: [],
    });
    this.handleSendAction("SHOPPING_CART_LOADING", true);

    const { laundryOrder, cartProducts, selectedCustomer } = this.state;
    const customer_Id = this.state.isB2bActive
      ? {
          business_account_customer_id: (selectedCustomer as CustomerDataType)
            .id,
        }
      : { customer_id: (selectedCustomer as CustomerDataType).id };
    const putBody = {
      data: {
        orderId: (laundryOrder as IlaundryOrder).id,
        ...customer_Id,
        store_management_id: laundryOrder?.store_management_id,
        order_items_attributes: cartProducts
          .filter((item) => item.id !== undefined)
          .map((item) => ({
            id: item.id,
            _destroy: true,
          })),
      },
    };

    let message = makeApiMessage({
      url: configJSON.deleteOrderByIdEndpoint,
      body: JSON.stringify(putBody),
      method: "PUT",
    });
    cartProducts.forEach((item) => {
      if (item.catalogue_id) {
        this.resetProductQuantity(item.catalogue_id);
      }
    });
    this.setState({
      cartProducts: [],
    });
    this.updateOrderApiCallID = message.messageId;
    runEngine.sendMessage(message.id, message);
  }


  handleAddProductClick = () => {
    this.setState({ addProductPopup: true });
  };

  handleAddProductPopupClose = () => {
    this.setState({ addProductPopup: false, isEdit: false });
  };

  handleGetTemporaryProduct = (productInfo: { data: CatalogueList }) => {
    this.setState(
      {
        cataloguesList: [productInfo.data, ...this.state.cataloguesList],
        temporaryProducts: [...this.state.temporaryProducts, productInfo.data],
      },
      () => {
        this.setState({
          addProductPopup: false,
        });
      }
    );
  };

  handleCloseEditPreferencesPopup = () => {
    this.setState({
      isEditPreferencesPopupOpen: false,
    });
  };

  getSpecificatonBodyObj = (selecredSpecifications: EditSpecificationType) => {
    const transformedObj = Object.keys(selecredSpecifications).reduce(
      (
        accVal: {
          [key: string]: string[];
        },
        keyVal
      ) => {
        const options = selecredSpecifications[keyVal].map(
          (item) => item.option
        );
        if (options.length > 0) {
          accVal[keyVal] = options;
        }
        return accVal;
      },
      {}
    );

    return transformedObj;
  };

  getUpdatePreferenceBody = (
    updatedPreferencesData: SelectedPreferenceData[]
  ) => {
    const { laundryOrder } = this.state;

    const editedPreference = updatedPreferencesData.map((updatePreference) => {
      return {
        id: updatePreference.order_items_preference_id,
        order_item_id: updatePreference.order_items_id,
        preference_id: updatePreference.selected_preference,
        upcharge_list_ids: updatePreference.selected_upcharges,
        specifications: this.getSpecificatonBodyObj(
          updatePreference.selected_specifications
        ),
      };
    });

    const updateBody = {
      id: laundryOrder?.id,
      order_item_preferences: editedPreference,
    };

    return updateBody;
  };

  handleFetchCatalogues = () => {
    const { selectedCustomer } = this.state;
    if (this.state.isB2bActive) {
      this.setState(
        {
          currentPage: 1,
        },
        () => this.getCatalogueList()
      );
      return;
    } else {
      const use_customer_price_list =
        selectedCustomer?.attributes.customer_profile.data.attributes
          .use_customer_price_list;
      if (use_customer_price_list && selectedCustomer) {
        this.setState(
          {
            userCustomerPriceList: true,
            userCustomerPriceListId:
              selectedCustomer.attributes.customer_profile.data.attributes
                .price_list.data.attributes.id,
            currentPage: 1,
          },
          () => this.getCatalogueList()
        );
      }
    }
  };

  handleCustomInpputQty = (orderItem: StoreOrderItem) => {
    const { laundryOrder, selectedCustomer } = this.state;
    const customer_Id = this.state.isB2bActive
      ? {
          business_account_customer_id: (selectedCustomer as CustomerDataType)
            .id,
        }
      : { customer_id: (selectedCustomer as CustomerDataType).id };
    const putBody = {
      data: {
        ...customer_Id,
        store_management_id: laundryOrder?.store_management_id,
        order_items_attributes: [
          {
            id: orderItem.id,
            quantity: orderItem.attributes.quantity,
            _destroy: orderItem.attributes.quantity == 0 ? true : false,
          },
        ],
      },
    };

    this.setState({ isLoading: true });
    let message = makeApiMessage({
      url: this.state.isB2bActive
        ? `${configJSON.bussinessUpdateOrderEndPoint}?id=${
            (laundryOrder as IlaundryOrder).id
          }`
        : configJSON.actionOrderByIdEndpoint +
          (laundryOrder as IlaundryOrder).id,
      body: JSON.stringify(putBody),
      method: "PUT",
    });
    this.updateOrderApiCallID = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  getCatalogueDataBasedOnCondition = (catalogueId: number) => {
    let selectedProductData = null;
    const selectedServicePresentInCart = this.state.cartProducts.some(
      (cartItem) => catalogueId === cartItem.catalogue_id
    );
    if (
      catalogueId
      // this.state.selectedService?.id && selectedServicePresentInCart
    ) {
      // selectedProductData = this.state.cartProducts.find(
      //   (product: ICartProductItem) =>
      //     product?.id === catalogueId
      //     // product?.category_id === this.state.tabsId &&
      //     // product.service_id === this.state.selectedService?.id
      // );

      if (
        // this.state.isIncreaseBtnClicked &&
        this.state.cartProducts.find(
          (cart) => cart.catalogue_id === catalogueId
        )
      ) {
        selectedProductData = lodash.findLast(
          this.state.cartProducts,
          (product: ICartProductItem) => product?.catalogue_id == catalogueId
          // &&
          // product?.category_id === this.state.tabsId
        );
      }
    } else {
      if (
        // this.state.isIncreaseBtnClicked &&
        this.state.cartProducts.find(
          (cart) => cart.catalogue_id === catalogueId
        )
      ) {
        selectedProductData = lodash.findLast(
          this.state.cartProducts,
          (product: ICartProductItem) => product?.catalogue_id === catalogueId
          // &&
          // product?.category_id === this.state.tabsId
        );
      } else {
        selectedProductData = this.state.cartProducts.find(
          (product: ICartProductItem) => product?.catalogue_id === catalogueId
          // &&
          // product?.category_id === this.state.tabsId
        );
      }
    }
    return selectedProductData;
  };

  getPaymentMethods() {
    const message = makeApiMessage({
      url: configJSON.getPaymentMethodsListApi,
      method: "GET",
    });
    this.getPaymentMethodsApiCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  }

  handlePaymentMethodsResponse(response: {
    status: 200;
    data: PaymentMethodType[];
  }) {
    if (response.status == 200 && response.data) {
      const data = response.data;
      if (data) {
        let cleanedData = data.map((item): any => ({
          ...item,
          name: item.name.trim(),
        }));
        const string_data = JSON.stringify(cleanedData);
        localStorage.setItem("payment_method_lists", string_data);
      }
    }
  }

  handleGetPaymentAPI = () => {
    setTimeout(() => this.getPaymentMethods(), 3000);
  };

  resetAllProductQuantities = () => {
    this.setState({
      selectedProductQuantity: {},
    });
  };

  // Customizable Area End
}
